import LoginComponent from "../../components/login/LoginComponent";


export default function LoginBloc() {

    
      return (  
        <div className="bloc-coadherent--connexion bloc-connexion shadow-bleu va-center">
            <div className="bg-blanc p-lg">
                <h2 className="card-title bleu mb-xs">Se connecter à votre parcours d'adhésion</h2>
                <p className="text mb-lg">Cette information est nécessaire pour  pré-compléter votre parcours et simplifier vos démarches.</p>
                <LoginComponent/>
            </div>
        </div>
    )
}